import { server } from '@/services/'
import moment from 'moment'
import orderBy from 'lodash/orderBy'

const state = {
  events: [],
  initialEvents: [],
  cleaners: []
}

const mutations = {
  setInitialEvents (state, payload) {
    state.initialEvents = payload
  },
  setEvents (state, payload) {
    state.events = payload
  },
  setCleaners (state, payload) {
    state.cleaners = payload
  }
}

const actions = {
  fetchEvents({ commit }, payload) {
    return new Promise((resolve) => {
      payload.startDate = moment(payload.startDate).format('YYYY-MM-DD')
      payload.endDate = moment(payload.endDate).format('YYYY-MM-DD')
      server.get('/events', payload).then(
        resp => {
          let result = orderBy(resp.data.msgContent.data, 'createdAt', 'desc')
          commit('setEvents', result)
          resolve()
        }
      )
    })
  },
  fetchCleaners({ commit }) {
    return new Promise((resolve) => {
      server.get('/getUA_Cleaners').then(
        resp => {
          let result = resp.data.msgContent.data.map(obj => ({
            text: `${obj.USER_PROFILE_FIRST_NAME} ${obj.USER_PROFILE_LAST_NAME}`,
            value: obj.USER_NAME
          }))
          commit('setCleaners', result)
          resolve()
        }
      )
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
